import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <Section data-id="element-270" data-mp="3mf7pges1bkaz">
      <Eyebrow data-id="element-271" data-mp="3mfhh06sq9zis">What welders are saying</Eyebrow>
      <Heading data-id="element-272" data-mp="3r80w5872d2pp">Real experiences from the workshop</Heading>

      <ul className="mt-9 space-y-4" data-id="element-273" data-mp="3r9lp4tdqcdlg">
        {testimonials.map(t => <li key={t.name} className="rounded-2xl border border-ink-600 bg-ink-800 p-5" data-id="element-274" data-mp="o9idnevx2e">
            <div className="flex items-center gap-4" data-id="element-275" data-mp="41hxt84rndvt">
              <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover" width={128} height={128} loading="lazy" data-id="element-276" data-mp="925nnqh9doog" />
              <div data-id="element-277" data-mp="2autvye8rf2b3">
                <p className="font-display text-lg font-extrabold uppercase leading-tight tracking-wide text-white" data-id="element-278" data-mp="2avdb5n70zclf">
                  {t.name}
                </p>
                <p className="text-[13px] text-zinc-400" data-id="element-279" data-mp="1slay5ijo6p94">{t.role}</p>
                <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-280" data-mp="1ntarl793gy3k">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-spark text-spark" aria-hidden="true" data-id="element-281" data-mp="1iuzjp22d0xnz" data-mpi={i} />)}
                </div>
              </div>
            </div>
            <blockquote className="mt-4 text-[15px] leading-relaxed text-zinc-200" data-id="element-282" data-mp="26lde2z8f38lq">
              “{t.quote}”
            </blockquote>
          </li>)}
      </ul>

      <p className="mt-9 text-center font-display text-xl font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-283" data-mp="1xjw0pome9l0q">
        Join welders who are replacing guesswork with a process
      </p>
      <div className="mt-4" data-id="element-284" data-mp="m4gvxyny1ov2">
        <CTAButton data-id="element-285" data-mp="m47a8n9xm3v6" />
      </div>
    </Section>;
}